import React, { Component, Fragment } from 'react';
import { arrayOf, object, shape, string, func, bool } from 'prop-types';
import FilterContainer, { Subscribe } from 'js/containers/filter';
import Filter from 'components/filter/component';
import Result from './result';

class DataReleaseArchiveFilter extends Component {

    static propTypes = {
        config: shape( {
            attributes: shape( {
                data: shape( {
                    filters: arrayOf( shape( {
                        name: string.isRequired,
                        facets: arrayOf( shape( {
                            name: string.isRequired,
                            query: object.isRequired
                        } ) )
                    } ) ).isRequired,
                    results: arrayOf( shape( {
                        attributes: shape( {
                            year: string.isRequired,
                            url: string.isRequired,
                            title: string.isRequired,
                            pdf: bool.isRequired
                        } )
                    } ) ).isRequired
                } )
            } )
        } ).isRequired,
        container: shape( {
            state: object,
            updateStatefromData: func.isRequired
        } ).isRequired
    };

    constructor( props ) {

        super( props );

        const years = props.config.filters[0].facets.map( ( x ) => parseInt( x.name ) );

        const previousYear = Math.max.apply( null, years );

        const currentYearValue = {
            label: previousYear,
            value: previousYear.toString()
        };

        this.state = {
            currentResult: this.getResults( currentYearValue ),
            currentYearValue
        };

    }

    getResults = ( currentYearValue ) => {

        const results = this.props.config.results.filter( ( result ) => {

            return result.attributes.year === currentYearValue.value;

        } );

        return results;

    };

    onFilterChange = ( selectedOption ) => {

        const result = this.getResults( selectedOption );

        this.setState( {
            currentYearValue: selectedOption,
            currentResult: result
        } );

    };

    renderFilters = () => {

        return this.props.config.filters.map( ( filter ) => {

            return (
                <Filter
                    key={ filter.name }
                    filter={ filter }
                    labelId='filter-title'
                    onChange={ this.onFilterChange }
                    container={ this.props.container }
                    updateState={ this.props.container.updateStatefromData }
                    value={ this.state.currentYearValue }

                />
            );

        } );

    };

    renderResults = ( ) => {

        return this.state.currentResult.map( ( result ) => {

            return <Result key={ result.id } { ...result } />;

        } );

    };

    render() {

        return (
            <Fragment>

                <p className='filter-title'>Filter by:</p>

                <div className='filter-section'>
                    { this.renderFilters() }
                </div>

                { this.renderResults() }

            </Fragment>

        );

    }

}

const withSubscribe = ( props ) => (
    <Subscribe to={ [ FilterContainer ] }>
        { ( container ) => (
            <DataReleaseArchiveFilter
                config={ props.config.attributes.data }
                data={ container.state }
                container={ container }
            />
        ) }
    </Subscribe>
);

withSubscribe.propTypes = DataReleaseArchiveFilter.propTypes.config;

export default withSubscribe;